import {UpdateToolbarCallback} from "@fd/editors/html/plugins/SelectionListenerPlugin.ts";
import { Plugin, EditorState, PluginKey} from "prosemirror-state";
import { EditorView } from "prosemirror-view";
import {MUTATING} from "@fd/editors/html/commands/Mutating.ts";

export function createToolbarUpdatePlugin(updateToolbar: UpdateToolbarCallback): Plugin {
	const toolbarUpdatePlugin =  new Plugin({
		key: new PluginKey("updateToolbar"),

		state: {
			init() {
				return false; // No mutable transaction yet
			},
			apply(tr, mutable) {
				// Check if this transaction has the "mutable" meta
				return !!tr.getMeta(MUTATING);
			},
		},

		view(editorView: EditorView) {
			return {
				update(view, prevState) {
					const pluginState = toolbarUpdatePlugin.getState(view.state);
					if (pluginState) {
						// Update the toolbar only if a "mutable" transaction was applied
						console.log("Was mutating command");
						updateToolbar(view.state);
					}
				},
			};
		},
	});
	return toolbarUpdatePlugin;
}
